<template>
  <ModalDialog
    ref="dialog"
    title="Edit Supplier Details"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-industry"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="contactForm" :labelColumnSize="3">
      <FormRow label="Supplier Type"><FormSelect v-model="contact.supplierType" field="supplierType" :options="supplierTypeOptions" /></FormRow>
      
      <FormRow label="Credit Type"><FormSelect v-model="contact.supplierCreditType" field="supplierCreditType" :options="creditTypeOptions" /></FormRow>
      <FormRow label="Payment Terms" v-show="contact.supplierCreditType == creditTypes.account">
        <div class="input-group input-payment-terms-group">
          <FormInputText v-model="contact.supplierPaymentTermsAmount" field="supplierPaymentTermsAmount" class="input-group-prepend" />
          <FormSelect v-model="contact.supplierPaymentTermsType" :options="paymentTermOptions" field="supplierPaymentTermsType" />
        </div>
      </FormRow>

      <FormRow label="Landing Cost"><FormSelect v-model="contact.landingCostType" :options="landingCostOptions"/></FormRow>
      <FormRow v-show="contact.landingCostType == 'fixed'" label="Landing Fixed Price">
        <FormInputCurrency placeholder="Fixed Landing Price" v-model="contact.landingFixedValue" field="landingFixedValue" :addon="accountCurrencyCode" />
      </FormRow>
      <FormRow v-show="contact.landingCostType == 'percent'" label="Landing Percent Price">
        <FormInputText type="number" placeholder="Percent Landing Price" v-model="contact.landingPercentValue" field="landingPercentValue" addon="%" />
      </FormRow>
      
      <FormRow label="Lead Time (days)" suffix="days"><FormInputText type="number" placeholder="Lead Time" v-model="contact.supplierDeliveryLeadDays" field="supplierDeliveryLeadDays" /></FormRow>
      <FormRow label="Currency">
        <FormSelect v-model="contact.supplierCurrencyCode" :optionsPromise="currencyOptionsPromise" field="supplierCurrencyCode" />
        </FormRow>

      <FormRow label="Tax Type">
        <FormSelect v-model="contact.supplierTaxRateId" :optionsPromise="taxRateOptionsPromise" field="supplierTaxRateId" />
      </FormRow>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import { CreditTypeLookup, CreditTypes, PaymentTermLookup, DeliveryPricingTypes, SupplierTypeLookup } from '@/store/types'

export default {
  name: "ContactEditSupplierDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    contactId: Number,
    isCreateMode: Boolean
  },
  data() {
    return {
      contact: {
        isCustomer: false,
        isSupplier: false,
        labelList: []   // JB FIXME: Have to reset this as label control doesn't listen... 
      },
      contactForm: {},
      submitting: false,
      landingCostOptions: [
        { value: 'fixed', name: 'Fixed' },
        { value: 'percent', name: 'Percentage' }
      ],
      supplierTypeOptions: SupplierTypeLookup,
      creditTypeOptions: CreditTypeLookup,
      creditTypes: CreditTypes,
      paymentTermOptions: PaymentTermLookup,
      currencyOptionsPromise: this.getCurrencyOptionsPromise(),
      taxRateOptionsPromise: this.getTaxRateOptionsPromise(),
    }
  },
  mounted() {
  },
  computed: {
    ...mapState({
      accountCurrencyCode: state => state.account.currencyCode,
    })
  },
  methods: {
    show(contact) {
      // Reset form
      this.contact = {
        labelList: []
      }
      this.contactForm = {}
      this.submitting = false

      if(contact != null) {
        this.contact = _.cloneDeep(contact)
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var contactData = _.cloneDeep(this.$data.contact)
      var updateData = _.pick(contactData, [
        'supplierType', 'supplierCreditType', 'landingCostType', 'supplierDeliveryLeadDays', 'supplierCurrencyCode', 'supplierTaxRateId'
      ])
      if(this.$data.contact.supplierCreditType == CreditTypes.account)
        updateData = _.merge(updateData, _.pick(contactData, ['supplierPaymentTermsAmount', 'supplierPaymentTermsType']))

      if(this.$data.contact.landingCostType == DeliveryPricingTypes.fixed)
        updateData = _.merge(updateData, _.pick(contactData, ['landingFixedValue']))
      if(this.$data.contact.landingCostType == DeliveryPricingTypes.percent)
        updateData = _.merge(updateData, _.pick(contactData, ['landingPercentValue']))

      this.$apiService.contactService.updateContactSupplier(this.contactId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.contactForm = this.processFormResponse(err)
        })
    },
    getCurrencyOptionsPromise() {
      return new Promise((resolve, reject) => {
        return this.$apiService.coreService.getCurrencyList()
        .then(response => {
          var currencyOptions = response.data.map(currency => {
            return { value: currency.targetCode, name: currency.targetCode }
          })
          resolve(_.concat({ value: null, name: 'None' }, currencyOptions))
        })
        .catch(err => { reject(err) })
      })
    },
    getTaxRateOptionsPromise() {
      return new Promise((resolve, reject) => {
        return this.$apiService.adminService.getTaxRateList()
        .then(response => {
          var taxRateOptions = response.data.map(taxRate => {
            return { value: taxRate.id, name: taxRate.displayName }
          })
          resolve(_.concat({ value: null, name: 'None' }, taxRateOptions))
        })
        .catch(err => { reject(err) })
      })
    }
  }
}
</script>